import React, { useEffect } from 'react';
import { MdClose, MdStars, MdLocalMovies } from 'react-icons/md';

export default function RewardPopup({ reward, onClose }) {
  useEffect(() => {
    // Auto close after 5 seconds for non-coupon rewards
    if (reward && reward.type !== 'movie_coupon') {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [reward, onClose]);

  if (!reward) return null;

  const getIcon = () => {
    switch (reward.type) {
      case 'points':
        return <MdStars />;
      case 'movie_coupon':
        return <MdLocalMovies />;
      default:
        return <MdStars />;
    }
  };

  const getTitle = () => {
    switch (reward.type) {
      case 'points':
        return 'Points Awarded!';
      case 'movie_coupon':
        return 'Movie Coupon Unlocked!';
      default:
        return 'Reward Unlocked!';
    }
  };

  return (
    <div className="reward-popup-overlay" onClick={onClose}>
      <div className="reward-popup" onClick={(e) => e.stopPropagation()}>
        <button className="reward-popup-close" onClick={onClose}>
          <MdClose />
        </button>
        <div className="reward-popup-icon">
          {getIcon()}
        </div>
        <h2 className="reward-popup-title">{getTitle()}</h2>
        <p className="reward-popup-message">{reward.message}</p>
        {reward.type === 'movie_coupon' && (
          <div className="reward-popup-note">
            <p>Our team will reach out to your email within 1-2 days.</p>
            <p>Please check your mail for further instructions.</p>
          </div>
        )}
      </div>
    </div>
  );
}

